import { Button, Descriptions, Drawer, Image, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import {
  CloseOutlined,
  EditOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import LocationModal from "../../merchant/products/LocationModal";
const ProductInfo = ({ open, close, selectedData, module, rerun }) => {
  const [localDialog, setLocalDialog] = useState(false);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          height: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  close();
                }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        <Descriptions
          //  title="Product Image"
          column={1}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Image
              width={"auto"}
              height={150}
              src={
                selectedData.product_image !== null
                  ? `${process.env.REACT_APP_API_IMAGE}products/${selectedData.product_image}`
                  : require("./../../../assets/empty.png")
              }
              placeholder={"logo"}
              preview={selectedData.product_image !== null ? true : false}
            />
          </div>
        </Descriptions>

        <Descriptions
          // title="Product Info"
          column={1}
        >
          <Descriptions.Item
            label="Product"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.product}
          </Descriptions.Item>
          {selectedData.description !== null && (
            <Descriptions.Item
              label="Description"
              contentStyle={{
                fontWeight: "bold",
              }}
            >
              {selectedData.description}
            </Descriptions.Item>
          )}

          <Descriptions.Item
            label="Price"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            &#8369;{selectedData.price}
          </Descriptions.Item>
          <Descriptions.Item
            label="Status"
            contentStyle={{
              fontWeight: "bold",
              color: parseInt(selectedData.status) === 1 ? "green" : "red",
            }}
          >
            {parseInt(selectedData.status) === 1 ? "Available" : "Unavailable"}
          </Descriptions.Item>
        </Descriptions>

        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            // display: module === "merchant" ? "flex" : "none",
            display: "flex",
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Typography style={{ fontWeight: "bold", fontSize: 16 }}>
              Location
            </Typography>
          </div>
          <div>
            <Tooltip
              title={
                selectedData.productslocation !== null
                  ? "Edit Location"
                  : "Create Location"
              }
            >
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setLocalDialog(true);
                }}
                icon={
                  selectedData.productslocation !== null ? (
                    <EditOutlined />
                  ) : (
                    <FileAddOutlined />
                  )
                }
              />
            </Tooltip>
          </div>
        </div>

        <Descriptions
          column={1}
          // title="Location"
          style={{
            marginTop: 10,
            // display: module === "merchant" ? "block" : "none",
            display: "flex",
          }}
        >
          <Descriptions.Item
            label="Floor"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.productslocation !== null
              ? selectedData.productslocation.floor
              : ""}
          </Descriptions.Item>
          <Descriptions.Item
            label="Row/Lane"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.productslocation !== null
              ? selectedData.productslocation.lane
              : ""}
          </Descriptions.Item>
          <Descriptions.Item
            label="Shelf"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.productslocation !== null
              ? selectedData.productslocation.shelf
              : ""}
          </Descriptions.Item>
          <Descriptions.Item
            label="Tray"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.productslocation !== null
              ? selectedData.productslocation.tray
              : ""}
          </Descriptions.Item>
        </Descriptions>
      </div>

      {localDialog && (
        <LocationModal
          open={localDialog}
          close={() => setLocalDialog(false)}
          closeDrawer={() => close()}
          product_id={selectedData.id}
          dataSet={selectedData.productslocation}
          rerun={() => rerun()}
        />
      )}
    </Drawer>
  );
};

export default ProductInfo;
